import React, { useEffect } from "react";
import { useGenericContext } from "@/context/generic";
import { IS_PRODUCTION } from "@/helpers/CompileHelper";

const ThankYou = (props) => {
    const { state, dynamicStorage } = useGenericContext();

    useEffect(() => {
        if (!state.funnel?.submitted) return;

        dynamicStorage().removeItem(state.key);
        setTimeout(() => {
            if (IS_PRODUCTION) {
                window.location = "https://mekle.no/bestridte-krav-azets/";
            } else {
                // window.location = "https://mekle.no/bestridte-krav-azets/";
                console.log("Dersom produksjon ville kunden blitt sendt videre til annen side...")
            }
        }, 5000)
    }, [state.funnel?.submitted])

    return (
        <div>
            <h1>
                Takk.
            </h1>
            <h4>
                Du vil høre fra oss innen kort tid.
            </h4>
        </div>
    );
};

export default ThankYou;
